import React from "react";

const ReadMoreList = () => {
  return (
    <section className="confirm-section--notes">
      <h3 className="h3 ">Terms & Conditions</h3>
      <div className="confirm-section--notes-content">
        <ul className="m-0 ">
          <li className="pb-2">
            The above Rate is inclusive of Uniformed Chauffeur (with Mobile),
            Fuel and all Maintenance Costs.
          </li>
          <li className="pb-2">
            Night Charges (same as Outstation Night Charges) applicable for all
            Local Run between 10:00 pm to 06:00 am.
          </li>
          <li className="pb-2">
            5% GST on the Total Invoice amount will be applicable, as per Govt.
            directive.
          </li>
          <li className="pb-2">
            Time and Mileage are noted from Garage to Garage (in all cities). If
            detention exceeds 04 HR, inclusive of time from / to Garage, Full
            Day (08 HR/80 KM) duty becomes payable.
          </li>
          <li className="pb-2">
            All Interstate Taxes, Permit Fees, Toll Taxes, MCD tax, and Parking
            Charges etc. shall be extra as per actual. In cases where toll is
            Prepaid or E-toll, the number of trips with the amount of per-trip
            toll shall be mentioned on the signed Duty Slip.
          </li>
          <li className="pb-2">
            A pick-up address (for Guests) or the drop-off address (for Guests)
            is more than 50 KMs (Delhi, Gurgaon, Noida & Mumbai) or 70 KMs
            (Bangalore, Greater Noida, Navi Mumbai, Ghaziabad, Faridabad,
            Manesar) driven and outside a zone, then the Supplier shall charge a
            Guest at the “Excess KMs” charge for each KM over the 50 or 70 KM
            distance. The Supplier shall be responsible for recovering such
            excess charges directly from the Guest.
          </li>
          <li className="pb-2">
            In case a Tax Paid Car or UP registered car is used for Noida /
            Greater Noida / UP travel, a per-trip charge of Rs. 120 per Sedan
            vehicle & Rs. 180 per MUV per day would be levied to cover prepaid
            taxes.
          </li>
          <li className="pb-2">
            In case of Fuel Hike, an increase of every Rs.1 in Fuel Price will
            translate into a 0.75% increase in Price from the day of the Fuel
            Hike in the form of Fuel Surcharge. This would be effective only
            when the hike in prices is more than 5% from the day the agreement
            was signed.
          </li>
          <li className="pb-2">
            Satguru Mobility Private Limited (SMPL) shall not be held
            responsible for any belongings left by users in the vehicle or any
            losses incurred by the renter due to any reason.
          </li>
          <li className="pb-2">
            This Agreement is perpetually valid unless it is terminated by
            either of the parties by giving a minimum 01-month notice period.
          </li>
          <li className="pb-2">
            Cancellation Charges:
            <ul>
              <li className="pb-2">
                For Economy/Executive Cars: Cancellation made more than 04 hours
                before the duty reporting time: Nil. Cancellation within 04
                hours before dispatch or No Show once the car has left garage:
                Half day (04 HR/40 KMS).
              </li>
              <li className="pb-2">
                For Luxury, Royale, Vans, and Coaches: Cancellation made more
                than 48 hours before the duty reporting time: Nil. Cancellation
                charges up to 48 hours before dispatch or no show once car has
                left our garage: Full Day (08 HR/80 KMS).
              </li>
            </ul>
          </li>
          <li className="pb-2">
            Payments to be made within 15 days of presentation of bills. Any
            errors in bills must be brought to the notice of Satguru Mobility
            Private Limited (SMPL) within 05 days of presentation. No disputes
            will be entertained beyond 05 days of submission of bills in any
            case. Bills will be presented on Immediate / Weekly / Fortnightly /
            Monthly Basis. In no case will the amount of credit extended to hire
            exceed Rs. ________________. Without prejudice, Satguru Mobility
            Private Limited (SMPL) reserves the right to stop provision of
            services beyond the Credit Limit.
          </li>
          <li className="pb-2">
            The trip may be recorded using either:
            <ul>
              <li className="pb-2">
                1) Drivers App - User is requested to sign/enter OTP on the
                driver’s App at the time of release of car. The KMs done will be
                displayed, but the same are subject to change in case of any
                data loss or app malfunction OR where the Driver’s App is not
                available due to any reason.
              </li>
              <li className="pb-2">
                2) Trip Sheet/Duty Slip – The user to note Time/Mileage on the
                duty slip before service completion. The signed duty slip at the
                time of service completion would be binding and liable for
                billing and payment.
              </li>
            </ul>
          </li>
          <li className="pb-2">
            The invoice would be sent by email with scanned copies of the Duty
            Slip and images of reimbursements for any Parking or Interstate Tax,
            etc. Any Toll paid by Fast Tag would be verified by the user on the
            Duty Slip. No separate receipt can be provided.
          </li>
          <li className="pb-2">
            Centralized Reservations may be confirmed by e-mail at{" "}
            <strong>CAR.RESERVATIONS@EUROPCAR.IN</strong> or using Satguru
            Mobility Private Limited (SMPL) Online booking tool or App. A
            minimum of 04 Hour notice is required for on-the-spot bookings,
            depending on availability. For advance bookings, car and service
            staff details can only be passed approximately 02 hours before
            reporting. Confirmation of reservations will be subject to the
            availability of cars/category.
          </li>
          <li className="pb-2">
            Rates for Luxury Coaches, Bulk Requirements of cars for events, and
            groups can be provided as per requirement.
          </li>
          <li className="pb-2">
            Disputes, if any, would be resolved as per the Indian Arbitration
            Act.
          </li>
          <li className="pb-2">
            Europcar International Self-Drive Car Rental & Europcar India
            International Chauffeur Driven Car Hire services can be availed
            globally in over 500+ cities across 140 countries worldwide. Rates &
            terms will be provided on a case-to-case basis as per your specific
            requirements.
          </li>
        </ul>
      </div>
    </section>
  );
};

export default ReadMoreList;
